export const TRAITS_FILTER_TITLE = 'Traits Filter';
export const PLAYERS_FILTER_TITLE = 'Players Filter';
export const TRAITS_FILTER_INFO =
  'Use this to filter for plays for a specific trait value';
export const PLAYERS_FILTER_INFO =
  'Use this to filter for plays where a specific player lined up in a specific position';
